import { Phone, ShieldCheck, Clock, UserX } from "lucide-react";
import { LeadForm } from "./LeadForm";
import { Reveal } from "./Reveal";
import { WhatsAppIcon } from "./Logo";
import { PHONE_TEL, PHONE_DISPLAY, WHATSAPP } from "./data";

const POINTS = [
  { icon: UserX, t: "Álnévvel is kitölthető" },
  { icon: Clock, t: "1 órán belül visszahívjuk" },
  { icon: ShieldCheck, t: "Díjmentes, kötelezettség nélkül" },
];

export const LeadSection = () => (
  <section id="ajanlat" data-testid="lead-section" className="bg-[var(--ivory-2)] py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid overflow-hidden rounded-[32px] bg-[var(--navy-dark)] lg:grid-cols-12">
        <div className="relative p-7 text-white sm:p-12 lg:col-span-5">
          <img src="/img/clean_interior.webp" alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-20" loading="lazy" />
          <div className="relative">
            <Reveal>
              <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#FF9A85]">Díjmentes Ajánlatkérés</p>
              <h2 className="font-display mt-4 text-3xl font-black leading-[1.02] tracking-tight sm:text-5xl">1 PERCES BIZALMAS AJÁNLATKÉRÉS</h2>
              <p className="mt-5 text-base leading-relaxed text-white/85 sm:text-lg">Álnévvel is kitölthető. 1 órán belül visszahívjuk a részletekkel.</p>
            </Reveal>
            <ul className="mt-8 space-y-3">
              {POINTS.map(({ icon: I, t }) => (
                <li key={t} className="flex items-center gap-3 text-[15px] font-semibold"><span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10"><I className="h-4 w-4" /></span>{t}</li>
              ))}
            </ul>
            <div className="mt-10 flex flex-col gap-3 sm:flex-row lg:flex-col xl:flex-row">
              <a href={PHONE_TEL} data-testid="lead-call-button" className="inline-flex items-center justify-center gap-2 rounded-full bg-[var(--cta)] px-6 py-3.5 font-bold text-white transition-[transform,background-color] hover:-translate-y-0.5 hover:bg-[var(--cta-hover)]">
                <Phone className="h-4 w-4" /> {PHONE_DISPLAY}
              </a>
              <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" data-testid="lead-whatsapp-link" className="inline-flex items-center justify-center gap-2 rounded-full border border-white/25 px-6 py-3.5 font-bold text-white transition-colors hover:bg-white/10">
                <WhatsAppIcon className="h-5 w-5" /> WhatsApp
              </a>
            </div>
          </div>
        </div>
        <div className="bg-white p-6 sm:p-12 lg:col-span-7">
          <Reveal delay={0.1}>
            <LeadForm prefix="lead" />
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
